import { Injectable } from '@angular/core';

import { map, Observable, of, share } from 'rxjs';

import { WinType } from '@reg/shared/model';
import { HttpServiceHelper } from '@reg/shared/service/http-service-helper';
import { IJsonApiResponse } from '../json-api/json-api.interface';
import { observableInSeparateThread } from '../helper/observable-helper';

/**
 * Service to get winTypes
 */
@Injectable()
export class WinTypeService {
    public static INCLUDE_DIVISION_PROFILE: string = 'divisionProfile';
    private cachedWinTypesMap: { [apiRequest: string]: { obs: Observable<WinType[]>, records: WinType[] } } = {};

    /**
     * Constructor
     */
    constructor(private http: HttpServiceHelper) {
    }

    /**
     * Get all win types
     */
    public getIndex(
        included: string[] = null,
        queryParams: string[] = null,
        forceRefresh: boolean = false,
    ): Observable<WinType[]> {
        let apiUrl: string = `${this.http.configService.getApiBaseUrl()}/win-types/`;
        apiUrl += this.http.getQueryParameters(included, queryParams);

        if (!forceRefresh &&
            this.cachedWinTypesMap[apiUrl]) {
            if (this.cachedWinTypesMap[apiUrl].records) {
                return observableInSeparateThread(
                    this.cachedWinTypesMap[apiUrl].records.map((s: WinType) => s.clone()),
                );
            }
            return this.cachedWinTypesMap[apiUrl].obs;
        }
        // Make the http request
        this.cachedWinTypesMap[apiUrl] = { obs: null, records: null };

        this.cachedWinTypesMap[apiUrl].obs = this.http.get(apiUrl)
            .pipe(
                map((response: IJsonApiResponse) => {
                    const winTypes: WinType[] = [];
                    const bodyData: any = response.data || [];
                    for (const winType of bodyData) {
                        winTypes.push((new WinType()).deserialize(winType, response.included));
                    }
                    this.cachedWinTypesMap[apiUrl].records = winTypes;
                    return winTypes.map((x: WinType) => x.clone());
                }),
                share(),
            );

        return this.cachedWinTypesMap[apiUrl].obs;
    }
}
